import { Map as ImmutableMap } from 'immutable';
import getUserView from 'documents-ui/lib/getUserView';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import SearchContentTypes from 'SalesContentIndexUI/data/constants/SearchContentTypes';
export const documentToSearchResultCHIRP = (document, userId) => SearchResultRecord.initFromJS({
  contentId: document.id,
  contentType: SearchContentTypes.DOCUMENT,
  createdAt: document.createdAt,
  metadata: ImmutableMap({
    numShares: 0,
    numViews: 0
  }),
  name: document.title,
  updatedAt: document.updatedAt,
  userId,
  userView: getUserView(userId)
});
export default (documentData => SearchResultRecord.initFromJS({
  contentId: documentData.get('id'),
  contentType: SearchContentTypes.DOCUMENT,
  createdAt: documentData.get('createdAt'),
  metadata: ImmutableMap({
    numShares: 0,
    numViews: 0
  }),
  name: documentData.get('title'),
  updatedAt: documentData.get('updatedAt'),
  userId: documentData.get('userId'),
  userView: getUserView(documentData.get('userId'))
}));